export default {
      id: "Icon--socialInstagram-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--socialInstagram",
      toString: function () {
        return this.url;
      }
    }